<template>
  <div>
    <v-toolbar
      app
      clipped-left
      extended
      :extension-height="extensionHeight"
      class="elevation-2"
    >
      <v-progress-linear
        class="ma-0 mx-0 px-0"
        slot="extension"
        :indeterminate="true"
        color="success"
        :active="$store.state.loading"
        height="3"
      ></v-progress-linear>
      <v-toolbar-side-icon @click="toggleSidebar"></v-toolbar-side-icon>

      <v-toolbar-title>Tugende Links</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat :to="rootUrl" v-if="!isTabletOrMobileView">
          <span class="hidden-sm-and-down">Home</span>
        </v-btn>
        <v-btn flat :to="adminUrl" v-if="isAdmin && !isTabletOrMobileView">
          <span class="hidden-sm-and-down">Admin</span>
        </v-btn>
        <v-menu offset-y v-if="user">
          <v-btn flat slot="activator">
            <v-avatar size="30">
              <img :src="avatarUrl()" />
            </v-avatar>
          </v-btn>
          <v-list>
            <v-list-tile @click="logoutFunction">
              <v-list-tile-title>logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn flat v-else @click="loginFunction">login</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer
      v-model="drawer.open"
      dark
      clipped
      :permanent="drawer.permanent"
      app
      hide-overlay
      :mini-variant="showMiniVariant"
      v-if="hasSidebar"
    >
      <v-divider dark></v-divider>
      <v-list class="pt-5" dense>
        <!--<v-list-tile v-for="item in items" :key="item.title" @click="item.clickHandler">-->

        <template v-for="(item, index) in sidebarItems">
          <v-divider
            :key="item.title + index.toString()"
            v-if="index == 0"
          ></v-divider>
          <v-list-tile :key="item.title" :to="{ name: item.to }">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="index"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: {
        open: true,
        permanent: true,
        miniVariant: this.viewWidth <= 960
      }
    };
  },
  props: {
    user: {
      required: true,
      validator: prop => typeof prop === "object" || prop === null
    },
    loginFunction: Function,
    logoutFunction: Function,
    viewWidth: {
      type: Number,
      required: true
    },
    hasSidebar: {
      type: Boolean,
      default: false
    },
    sidebarItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    extensionHeight() {
      return this.$store.state.loading ? 3 : 0.01;
    },
    showMiniVariant() {
      // if isTabletOrMobileView, the result should always be true
      return this.drawer.miniVariant || this.isTabletOrMobileView;
    },
    isTabletOrMobileView() {
      return this.viewWidth <= 960;
    },
    isAdmin() {
      return this.user ? this.user.isAdmin : false;
    },
    rootUrl() {
      return this.getUrl("home");
    },
    adminUrl() {
      return this.getUrl("departments");
    }
  },
  methods: {
    getUrl(routeName) {
      let routeObject = this.$router.resolve({
        name: routeName
      });
      return routeObject.href;
    },
    goToRoute(routeName) {
      this.$router.push({ name: routeName });
    },
    avatarUrl() {
      // Returns avatars derived from User's initials e.g. for John Doe, you get JD if no photoURL
      if (this.user.photoURL) return this.user.photoURL;

      let userName =
        typeof this.user.displayName === "string"
          ? this.user.displayName
              .trim()
              .split(" ")
              .join("+")
          : "Anonymous";
      return `https://ui-avatars.com/api/?name=${userName}`;
    },
    toggleSidebarVisibilty() {
      this.drawer.permanent = !this.drawer.permanent;
      this.drawer.open = !this.drawer.open;
    },
    toggleSidebar() {
      if (this.drawer.open) {
        // if sidebar is open and is not miniVariant, make miniVariant
        // if sidebar is open and is miniVariant, close sidebar
        if (this.drawer.miniVariant || this.showMiniVariant) {
          this.toggleSidebarVisibilty();
        } else {
          this.drawer.miniVariant = true;
        }
      } else {
        // if sidebar is closed and is not the view is not of tablet or mobile,
        // open sidebar and make it non minivariant

        // if sidebar is closed and is the tablet or mobile,
        // open the sidebar and make it minivariant
        if (this.isTabletOrMobileView) {
          this.drawer.miniVariant = true;
        } else {
          this.drawer.miniVariant = false;
        }
        this.toggleSidebarVisibilty();
      }
    }
  }
};
</script>

<style>
.v-toolbar__extension {
  padding: 0 0px !important;
}
</style>
